import React from 'react';
import cn from 'classnames';
import plural from 'pluralize';
import { Card } from 'reactstrap';
import { getTotalDaySpan } from '~/utils/transfers';

const TransferScheduleSummaryCard = ({ className, transfers }) => {
  const totalTimeInDays = getTotalDaySpan(transfers);
  return (
    <Card className={cn(className, 'pa3')}>
      <h3 className="f4 mt0">Summary</h3>
      <h4 className="table-header mv0"># of steps</h4>
      <p>{transfers ? transfers.length : 0}</p>
      <h4 className="table-header mv0">Total transfer time</h4>
      <p>
        {totalTimeInDays} {plural('day', totalTimeInDays)}
      </p>
    </Card>
  );
};

export default TransferScheduleSummaryCard;



// WEBPACK FOOTER //
// ./src/components/transferScheduleSummaryCard/transferScheduleSummaryCard.jsx